// extracted by mini-css-extract-plugin
module.exports = {"styles":"styles___22OrH","title":"title___2xep2","prefix":"prefix___3SQhi","dot":"dot___eytW5","dotHidden":"dotHidden___iAnEU"};